export default __webpack_public_path__ + "static/background-f4ee7595e8d037dd4a0e0e39a68667b3.mp4";